module.exports = __webpack_public_path__ + "media/packs/images/flags/AW-c4f820c4f3e9c06d21464547be8ff8e8.svg";